import { Injectable } from '@angular/core';
import { WorkOrderValidationAuthService } from '../../../../views/wo-validation/services/auth.service';

const defaultRoles = [
  'Chief',
  'Admin',
  'Filters',
  'FilterAdmin',
  'FilterChief',
  'FilterLeader',
  'FilterSupervisor',
  'FiltersQualityControl',
];

@Injectable({
  providedIn: 'root',
})
export class FilterValidationAuthService extends WorkOrderValidationAuthService {
  verified(): boolean {
    return this.lookForRolesNeeded([...defaultRoles]);
  }

  editReport(): boolean {
    return this.lookForRolesNeeded([...defaultRoles]);
  }

  sendReport(): boolean {
    return this.lookForRolesNeeded([...defaultRoles]);
  }

  onlyViewer(): boolean {
    return (
      this.lookForRolesNeeded([
        'FilterViewer',
        'FilterFontanaViewer',
        'Viewer',
      ]) &&
      !this.roles.find(
        (x) => !['FilterViewer', 'FilterFontanaViewer', 'Viewer'].includes(x)
      )
    );
  }

  viewOptions(): boolean {
    return this.lookForRolesNeeded([...defaultRoles]);
  }
}
